import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { fontNormal, fontBold, fontCondensed } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

export const PanelContainer = styled(Link)`
  text-decoration: none;
  min-width: 142px;
  width: 142px;
  border: 1px solid
    ${({ $isFeatured }) =>
      $isFeatured ? buildColor("navy", "700") : buildColor("grey", "300")};
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgb(235, 246, 255);

  &:not(:last-child) {
    margin-right: 8px;
  }

  &:first-child {
    margin-left: 16px;
  }

  &:last-child {
    margin-right: 16px;
  }

  &:hover > div:first-child {
    background-color: ${buildColor("grey", "100")};
  }

  &:hover > div:nth-child(2) {
    background-color: ${({ $isFeatured }) =>
      $isFeatured ? buildColor("navy", "900") : buildColor("grey", "100")};
  }
`;

export const InformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("white", "100")};
  padding: 12px 12px 8px;
  border-radius: 4px 4px 0 0;
`;

export const MtpWrapper = styled.div`
  display: flex;
  margin-bottom: 8px;
`;

export const Title = styled.span`
  color: ${buildColor("navy", "700")};
  font-family: ${fontBold};
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 14px;
`;

export const Description = styled.span`
  color: ${buildColor("navy", "900")};
  font-family: ${fontNormal};
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  height: 17px;
  text-transform: capitalize;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 8px;
`;

export const RaceWrapper = styled.div`
  height: 17px;
  display: flex;
  flex-flow: row nowrap;
`;

export const TrackNameWrapper = styled.span`
  font-family: ${fontNormal};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const RaceNumberWrapper = styled.span`
  font-family: ${fontNormal};
  align-self: flex-end;
`;

export const Value = styled.span`
  color: ${buildColor("green", "600")};
  font-family: ${fontBold};
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0;
  height: 20px;
  margin-bottom: 2px;
`;

export const Pick = styled.span`
  color: ${buildColor("grey", "900")};
  font-family: ${fontCondensed};
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1px;
  height: 14px;
`;

export const FooterWrapper = styled.div`
  border-radius: 0 0 3px 3px;
  ${({ $isFeatured }) =>
    $isFeatured
      ? css`
          background-color: ${buildColor("navy", "700")};
          color: ${buildColor("white", "100")};
        `
      : css`
          background-color: ${buildColor("grey", "000")};
          border-top: 1px solid ${buildColor("grey", "300")};
          color: ${buildColor("blue", "500")};
        `};
  ${({ isNewLayout }) =>
    isNewLayout
      ? css`
          justify-content: space-between;
          padding: 8px 12px;
          height: 48px;
        `
      : css`
          justify-content: center;
          height: 42px;
        `}
  display: flex;
  font-family: ${fontBold};
  font-weight: 500;
  letter-spacing: 0;
  font-size: 14px;
  align-items: center;
`;
